import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import { Wordmark } from "@/components/Wordmark";

const LINKS = [
  { label: "Capabilities", href: "#capabilities" },
  { label: "Systems", href: "#products" },
  { label: "Sovereign", href: "#sovereign" },
  { label: "Contact", href: "#contact" },
];

export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={cn(
        "fixed inset-x-0 top-0 z-50 transition-colors duration-300",
        scrolled ? "border-b border-ink-800/80 bg-ink-950/80 backdrop-blur-md" : "border-b border-transparent",
      )}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:px-8">
        <Wordmark />

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="font-mono text-[0.72rem] uppercase tracking-[0.18em] text-ink-400 transition-colors hover:text-ink-50"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          className="inline-flex h-9 items-center rounded-[var(--radius-md)] border border-signal-500/50 bg-signal-500/10 px-4 font-mono text-[0.72rem] uppercase tracking-[0.16em] text-signal-300 transition-colors hover:bg-signal-500/20"
        >
          Start a project
        </a>
      </div>
    </header>
  );
}
